<mat-dialog-content>
  <div class="message">パスワードを変更しました。</div>
  <div class="button-container">
    <button mat-raised-button (click)="onLogin()" class="login-btn">続けてログイン</button>
  </div>
</mat-dialog-content>
